@if (isLoading) {
  <mt-loader />
}

@if (previousPageUrl) {
  <mt-back-link [url]="previousPageUrl"></mt-back-link>
}

@if (title) {
  <div class="title">
    <h1>{{ title }}</h1>
    <ng-content select="[actions]"></ng-content>
  </div>
}

<ng-content></ng-content>
